export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.5.0';
//# sourceMappingURL=version.js.map